var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXGreenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1275_45883)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.658303 0L9.24272 13.2366L-0.720703 24H1.52227L10.2454 14.5754L17.2932 24H24.9237L14.4663 10.0172L23.7394 0H21.4969L13.4636 8.67708L6.97263 0H-0.658303ZM2.64118 1.64995H6.14679L21.6273 22.3496H18.1199L2.64118 1.64995Z",
    fill: "#72C420"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1275_45883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGreenLogo);
export default __webpack_public_path__ + "static/media/x-green-logo.2a1449da91acbf165107ade81bbe07fa.svg";
export { ForwardRef as ReactComponent };